import { ErrorModal, HelmetDexteel } from "@dexteel/mesf-core";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { useEffect, useState } from "react";
import { get } from "react-hook-form";
import { useParams } from "react-router-dom";
import { getCatalogTundishShrouds } from "../../../repositories/CatalogTundishShroudRepository";
import { TableTundishShroud } from "../components/TableTundishShroud";
import { useCatalogTundishShroudContext } from "../context/CatalogTundishShroudContext";
type Props = {};

export const CatalogTundishShroudPage = (props: Props) => {
  const { actions } = useCatalogTundishShroudContext();
  const { tundishShroudId } = useParams();

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  const getCatalogTundishShroudsFromAPI = async () => {
    setIsLoading(true);
    const resp = await getCatalogTundishShrouds();
    if (resp.ok) {
      const tundishShrouds = get(resp, "data.tables[0].rows", []);
      actions.setTundishShrouds(tundishShrouds);
    } else {
      setError(resp.message);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getCatalogTundishShroudsFromAPI();
  }, []);

  return (
    <>
      <HelmetDexteel title={"Tundish Shrouds"} />
      <Grid container justifyContent="center" alignItems="center">
        <Grid item md={12} xs={12} style={{ margin: 0 }}>
          <Paper
            elevation={1}
            style={{
              width: "100%",
              padding: "10px 0 20px",
              borderRadius: "0.75rem",
              height: "auto",
            }}
          >
            <TableTundishShroud
              tundishShroudId={tundishShroudId}
              isLoading={isLoading}
              getCatalogTundishShroudsFromAPI={getCatalogTundishShroudsFromAPI}
            />
          </Paper>
        </Grid>
      </Grid>
      <ErrorModal error={error} onHide={() => setError("")} />
    </>
  );
};
